import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const PersonCancel: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <>
      <path
        fillRule="evenodd"
        d="M19.304 7.507a5.728 5.728 0 0 0-5.728 5.728v3.11a5.728 5.728 0 0 0 5.728 5.728h.365a5.728 5.728 0 0 0 5.728-5.728v-3.11a5.728 5.728 0 0 0-5.728-5.728h-.365Zm-7.028 5.728a7.028 7.028 0 0 1 7.028-7.028h.365a7.028 7.028 0 0 1 7.028 7.028v3.11a7.028 7.028 0 0 1-7.028 7.028h-.365a7.028 7.028 0 0 1-7.028-7.028v-3.11Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M17.09 10.651a2.83 2.83 0 0 1-2.832 2.83h-1.221v1h1.221a3.83 3.83 0 0 0 3.332-1.938 3.895 3.895 0 0 0 3.396 1.986h5.045v-1h-5.045a2.896 2.896 0 0 1-2.896-2.88v-.017l-.5.002h-.5v.017Zm7.562 15.083c-.247-.095-.5-.18-.756-.255l-.252-.074-.233.123a8.379 8.379 0 0 1-7.833 0l-.233-.123-.253.074a9.612 9.612 0 0 0-6.926 9.223v4.426h22.656V35.89a8.752 8.752 0 0 1-1.3-.496v2.434H9.466v-3.126a8.317 8.317 0 0 1 5.747-7.9 9.677 9.677 0 0 0 8.563 0c.245.08.485.17.72.271.019-.456.072-.904.157-1.34ZM37.2 32.242l-8.707-8.707.92-.92 8.707 8.708-.92.919Z"
        clipRule="evenodd"
      />
      <path fillRule="evenodd" d="m29.41 32.244 8.743-8.655-.915-.924-8.743 8.655.915.924Z" clipRule="evenodd" />
    </>
  );

  const normalHover = (
    <>
      <path
        fillRule="evenodd"
        d="M19.304 7.507a5.728 5.728 0 0 0-5.728 5.728v3.11a5.728 5.728 0 0 0 5.728 5.728h.365a5.728 5.728 0 0 0 5.728-5.728v-3.11a5.728 5.728 0 0 0-5.728-5.728h-.365Zm-7.028 5.728a7.028 7.028 0 0 1 7.028-7.028h.365a7.028 7.028 0 0 1 7.028 7.028v3.11a7.028 7.028 0 0 1-7.028 7.028h-.365a7.028 7.028 0 0 1-7.028-7.028v-3.11Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M17.09 10.651a2.83 2.83 0 0 1-2.832 2.83h-1.221v1h1.221a3.83 3.83 0 0 0 3.332-1.938 3.895 3.895 0 0 0 3.396 1.986h5.045v-1h-5.045a2.896 2.896 0 0 1-2.896-2.88v-.017l-.5.002h-.5v.017Zm7.562 15.083c-.247-.095-.5-.18-.756-.255l-.252-.074-.233.123a8.379 8.379 0 0 1-7.833 0l-.233-.123-.253.074a9.612 9.612 0 0 0-6.926 9.223v4.426h22.656V35.89a8.752 8.752 0 0 1-1.3-.496v2.434H9.466v-3.126a8.317 8.317 0 0 1 5.747-7.9 9.677 9.677 0 0 0 8.563 0c.245.08.485.17.72.271.019-.456.072-.904.157-1.34Zm13.842 7.801L27.188 22.229l.92-.92 11.306 11.307-.92.919Z"
        clipRule="evenodd"
      />
      <path fillRule="evenodd" d="m28.105 33.536 11.352-11.238-.914-.923L27.19 32.612l.915.923Z" clipRule="evenodd" />
    </>
  );

  const xSmall = (
    <>
      <path
        fillRule="evenodd"
        d="M13.747 13.235a5.557 5.557 0 0 1 5.557-5.557h.365a5.557 5.557 0 0 1 5.557 5.557v.162h-4.24a2.764 2.764 0 0 1-2.764-2.748v-.018l-.632.003h-.631v.017a2.699 2.699 0 0 1-2.7 2.698h-.512v-.114Zm0 1.378v1.732a5.557 5.557 0 0 0 5.557 5.557h.365a5.557 5.557 0 0 0 5.557-5.557v-1.684h-4.24a4.029 4.029 0 0 1-3.396-1.864 3.965 3.965 0 0 1-3.332 1.816h-.511Zm5.557-8.577a7.2 7.2 0 0 0-7.2 7.2v3.11a7.2 7.2 0 0 0 7.2 7.198h.365a7.2 7.2 0 0 0 7.2-7.199v-3.11a7.2 7.2 0 0 0-7.2-7.199h-.365Zm11.689 29.902v5.305H7.995v-6.54a9.783 9.783 0 0 1 7.049-9.388l.32-.092.294.155a8.206 8.206 0 0 0 7.673 0l.294-.155.32.093c.25.073.499.156.742.249a8.837 8.837 0 0 0-.196 1.694 8.192 8.192 0 0 0-.703-.272 9.85 9.85 0 0 1-8.587 0 8.14 8.14 0 0 0-5.564 7.717V39.6h19.714v-4.29c.52.261 1.07.473 1.642.628Zm2.332-7.329 3.754 3.754 1.161-1.161-3.748-3.748 3.78-3.743-1.154-1.167-3.787 3.748-3.798-3.798-1.161 1.161 3.792 3.793-3.79 3.751 1.156 1.167 3.795-3.757Z"
      />
    </>
  );

  const xSmallHover = (
    <>
      <path
        fillRule="evenodd"
        d="M13.747 13.235a5.557 5.557 0 0 1 5.557-5.557h.365a5.557 5.557 0 0 1 5.557 5.557v.162h-4.24a2.764 2.764 0 0 1-2.764-2.748v-.018l-.632.003h-.631v.017a2.699 2.699 0 0 1-2.7 2.698h-.512v-.114Zm0 1.378v1.732a5.557 5.557 0 0 0 5.557 5.557h.365a5.557 5.557 0 0 0 5.557-5.557v-1.684h-4.24a4.03 4.03 0 0 1-3.396-1.864 3.965 3.965 0 0 1-3.332 1.816h-.511Zm5.557-8.577a7.2 7.2 0 0 0-7.2 7.2v3.11a7.2 7.2 0 0 0 7.2 7.198h.365a7.2 7.2 0 0 0 7.2-7.199v-3.11a7.2 7.2 0 0 0-7.2-7.199h-.365Zm11.689 31.69v3.517H7.995v-6.54a9.783 9.783 0 0 1 7.049-9.388l.32-.092.294.155a8.206 8.206 0 0 0 7.328.172 10.12 10.12 0 0 0-.242 1.87 9.847 9.847 0 0 1-7.543-.433 8.14 8.14 0 0 0-5.564 7.717V39.6h19.714v-2.325c.528.194 1.077.346 1.642.45Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M32.165 27.448 27.21 22.49l1.161-1.16 4.962 4.961 4.949-4.898 1.155 1.167-4.942 4.893 4.9 4.9-1.161 1.161-4.906-4.906-4.96 4.91-1.155-1.168 4.953-4.903Z"
        clipRule="evenodd"
      />{' '}
    </>
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};

export default PersonCancel;
